/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  let refreshing = false
  let activationRequested = false

  // После SKIP_WAITING новый service worker сразу перехватывает контроль над
  // страницей (controllerchange). Перезагружаем её один раз, чтобы исполнялся
  // новый бандл, а не старый из прекэша — иначе вкладка с открытым приложением
  // живёт на предыдущей версии до закрытия всех вкладок домена.
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!activationRequested || refreshing) {
      return
    }
    refreshing = true
    window.location.reload()
  })

  // Сгенерированный Workbox service worker слушает это сообщение и вызывает
  // self.skipWaiting() (см. service-worker.js в собранном приложении).
  const activateWaitingWorker = (registration: ServiceWorkerRegistration) => {
    if (registration.waiting) {
      activationRequested = true
      registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
  }

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; activating update.')
      activateWaitingWorker(registration)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
